import React from 'react'
import Loader from '../../common/component/loader/loader'
export default function FullPageLoader ({ requestCount }) {
  if (requestCount <= 0) return ''
  return <Loader loading />
}
